import { RouteRecordRaw } from 'vue-router'

import { REPORT_ROUTE_NAMES } from '@/modules/report/constants/ReportRouteNames'
import ReportLayout from '@/modules/report/layouts/ReportLayout.vue'
import ReportSales from '@/modules/report/pages/ReportSales.vue'
import ReportOverview from '@/modules/report/pages/ReportsOverview.vue'

export const reportRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/reports',
    component: ReportLayout,
    redirect: { name: REPORT_ROUTE_NAMES.OVERVIEW },
    children: [
      {
        path: 'overview',
        name: REPORT_ROUTE_NAMES.OVERVIEW,
        component: ReportOverview,
        meta: {
          pageTitle: 'Reports Overview',
        },
      },
      {
        path: 'sales',
        name: REPORT_ROUTE_NAMES.SALES,
        component: ReportSales,
        meta: {
          pageTitle: 'Sales Report',
        },
      },
      {
        path: 'show-insights',
        name: REPORT_ROUTE_NAMES.SHOW_INSIGHTS,
        component: () => import('@/modules/show/pages/ShowInsights.vue'),
        meta: {
          pageTitle: 'Show Insights',
        },
      },
    ],
  },
]
